import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  authenticated: false,
  profile: null,
  subscription: {
    name: '',
    price: '',
    description: ''
  },
  isLoginInProgress: false,
  pendingAccountSelection: false
}

export default {
  state,
  getters,
  mutations,
  actions
}
